import React from "react";

function renderCondition(condition) {
  if (condition.conditionType === "factorAverage") {
    return `Factor ${condition.factorId} average ${condition.operator} ${condition.threshold}`;
  } else if (condition.conditionType === "highestScoringFactor") {
    return "Highest scoring factor";
  } else {
    return JSON.stringify(condition);
  }
}

export default function QuestionFollowup({ question, currentAnswer, onAnswerChange }) {
  // Determine label: if question.label is missing, fallback to factorTitle or a default value.
  const label = question.label || question.factorTitle || "Follow-up";
  const isAggregate = question.type === "aggregateFactorFollowup";
  const followupTitle = isAggregate ? "Aggregate Follow-up:" : "Follow-up:";

  return (
    <div style={{ marginTop: "1rem", borderLeft: "4px solid #888", paddingLeft: "1em" }}>
      <strong>{followupTitle}</strong> {label}
      
      {question.factorDescription && (
        <p style={{ margin: "0.5rem 0", color: "#555" }}>{question.factorDescription}</p>
      )}
      
      <br />
      
      <textarea
        rows={3}
        value={currentAnswer}
        onChange={(e) => onAnswerChange(question.uniqueId, e.target.value)}
        style={{
          width: "100%",
          marginTop: "8px",
          padding: "10px",
          borderRadius: "4px",
          border: "1px solid #ddd",
          fontFamily: "Raleway, sans-serif"
        }}
        disabled={question.skip}
      />
      
      {question.skip && question.skipConditions && (
        <div style={{ marginTop: "0.5rem", color: "#888" }}>
          <strong>Skipped because:</strong>
          <ul style={{ margin: "0.5rem 0", paddingLeft: "1.5em" }}>
            {question.skipConditions.map((condition, index) => (
              <li key={index}>{renderCondition(condition)}</li>
            ))}
          </ul>
        </div>
      )}
      
      {question.aiDriven && (
        <p style={{ marginTop: "0.5rem", fontStyle: "italic", fontSize: "0.9rem" }}>
          AI Prompt: {question.aiPrompt}
        </p>
      )}
    </div>
  );
}
